import { forwardRef } from 'react';

import type CSS from 'csstype';

import type { IconName, IconSize } from '@similarweb/icons';
import { SWReactIcons } from '@similarweb/icons';

import type { ButtonProps } from './Button';
import { StyledIconButton } from './styles';

export type IconButtonProps = ButtonProps & {
  iconName: IconName;
  iconSize?: IconSize | CSS.Property.Height;
  placement?: 'left' | 'right';
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const {
    children,
    variant = 'primary',
    onClick,
    className,
    disabled,
    isLoading,
    isActive,
    iconName,
    iconSize = 'xs',
    placement = 'left',
  } = props;
  return (
    <StyledIconButton
      variant={variant}
      onClick={onClick}
      className={className}
      disabled={disabled}
      data-automation={props['data-automation']}
      isLoading={isLoading}
      isActive={isActive}
      indicator={props.indicator}
      ref={ref}
    >
      {placement === 'left' ? <SWReactIcons iconName={iconName} size={iconSize} /> : null}
      {children}
      {placement === 'right' ? <SWReactIcons iconName={iconName} size={iconSize} /> : null}
    </StyledIconButton>
  );
});
